import React from 'react';
import { X } from 'lucide-react';
import { GoogleSignInButton } from './GoogleSignInButton';
import { DiscordSignInButton } from './DiscordSignInButton';
import { GoogleUser, DiscordUser } from '../types';
import { isGoogleAuthConfigured, isDiscordAuthConfigured } from '../services/auth';

interface LoginModalProps {
  onClose: () => void;
  onSignIn: (user: GoogleUser | DiscordUser, token: string) => void;
  isDarkMode: boolean;
}

export const LoginModal: React.FC<LoginModalProps> = ({ onClose, onSignIn, isDarkMode }) => {
  const hasGoogleAuth = isGoogleAuthConfigured();
  const hasDiscordAuth = isDiscordAuthConfigured();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className={`relative w-full max-w-md rounded-2xl shadow-2xl ${
        isDarkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
        {/* Close Button */}
        <button
          onClick={onClose}
          className={`absolute top-4 right-4 p-2 rounded-full transition-colors ${
            isDarkMode 
              ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' 
              : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
          }`}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Modal Content */}
        <div className="p-8">
          <h2 className={`text-2xl font-bold mb-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>
            Sign In
          </h2>
          <p className={`text-sm mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Sign in to save your scores to the leaderboard
          </p>

          {/* Sign In Options */}
          <div className="space-y-3">
            {hasGoogleAuth && (
              <GoogleSignInButton onSignIn={onSignIn} isDarkMode={isDarkMode} />
            )}
            {hasDiscordAuth && (
              <DiscordSignInButton isDarkMode={isDarkMode} />
            )}
            {!hasGoogleAuth && !hasDiscordAuth && (
              <p className={`text-sm text-center ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                No authentication providers configured
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
